module.exports = __webpack_public_path__ + "media/images/icons/document-434063e07d74bed3d74301951fc5c7c6.svg";